var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogosVw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.424,
    height: 22.359,
    viewBox: "0 0 90.424 22.359",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_441",
    "data-name": "Grupo 441",
    transform: "translate(-1174.491 -24.56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_917",
    "data-name": "Trazado 917",
    d: "M145.165,133.593a11.179,11.179,0,1,0,11.187,11.183,11.179,11.179,0,0,0-11.187-11.183m-3,1.815a9.457,9.457,0,0,1,6.023,0c.159.053.164.1.1.244q-1.466,3.144-2.924,6.292c-.045.1-.063.252-.182.257-.14.005-.153-.162-.2-.261q-1.464-3.145-2.924-6.292c-.07-.15-.039-.192.107-.24m-5.257,4.057c0-.033,0-.067.04-.078l.088-.123a7.24,7.24,0,0,1,.972-1.21l.115-.119,0,0,.118-.128a.1.1,0,0,1,.085-.083l.159-.14a9.642,9.642,0,0,1,1.831-1.369c.148-.089.147.041.179.109q.648,1.388,1.289,2.778c.71,1.531,1.423,3.06,2.125,4.594a.472.472,0,0,0,.506.33c.507-.02,1.015-.018,1.522,0a.446.446,0,0,0,.478-.306q1.519-3.336,3.051-6.667c.119-.259.241-.516.355-.777.041-.093.078-.108.169-.054a10.194,10.194,0,0,1,3.462,3.314c.065.1.018.165-.023.244l-3.9,7.552q-.488.944-.978,1.887c-.037.071-.058.179-.156.174s-.114-.111-.147-.184c-.612-1.347-1.226-2.692-1.828-4.043a.453.453,0,0,0-.492-.314c-.521.018-1.043.015-1.564,0a.405.405,0,0,0-.431.277q-.9,2.005-1.813,4c-.044.1-.062.251-.181.256s-.145-.15-.194-.244q-2.44-4.672-4.875-9.346a.219.219,0,0,1-.012-.06.279.279,0,0,1,.043-.27m14.724,12.7a9.792,9.792,0,0,1-15.7-10.594l1.5,2.915,4.212,8.19c.019.037.039.074.06.109a.343.343,0,0,0,.64-.006c.163-.314.3-.642.446-.965q1.108-2.46,2.214-4.921a.442.442,0,0,1,.024-.058c.043-.067.053-.179.154-.176s.117.111.15.182q.652,1.42,1.3,2.842l1.332,2.919c.023.051.045.1.071.151a.359.359,0,0,0,.676,0q.348-.676.7-1.352L152,146.353l.592-1.138q.6-1.188,1.209-2.375c.214-.42.431-.84.651-1.266a9.693,9.693,0,0,1-2.825,10.59",
    transform: "translate(1040.5 -109.033)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Logo_VW_Comerciales",
    "data-name": "Logo VW Comerciales",
    transform: "translate(1206.109 24.561)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_924",
    "data-name": "Trazado 924",
    d: "M414.057,219.782a10.184,10.184,0,0,1-10.117-10.149,9.913,9.913,0,0,1,.64-3.544L410.5,218c.078.157.172.279.359.279a.392.392,0,0,0,.359-.279l2.717-6.1c.031-.062.062-.125.125-.125s.093.062.125.125L416.9,218a.393.393,0,0,0,.359.279c.186,0,.279-.124.359-.279l5.918-11.913a9.913,9.913,0,0,1,.64,3.544,10.184,10.184,0,0,1-10.118,10.149m0-12.444c-.062,0-.093-.062-.125-.125l-3.185-7.151a9.771,9.771,0,0,1,6.62,0l-3.185,7.151c-.031.062-.062.125-.125.125m-3.232,7.338c-.062,0-.093-.062-.125-.125l-5.152-10.383a10.458,10.458,0,0,1,3.638-3.419l3.7,8.244a.261.261,0,0,0,.279.186h1.78a.261.261,0,0,0,.279-.186l3.7-8.244a10.459,10.459,0,0,1,3.638,3.419l-5.152,10.383c-.031.062-.063.125-.125.125s-.093-.062-.125-.125l-1.936-4.434a.261.261,0,0,0-.279-.186h-1.779a.261.261,0,0,0-.279.186l-1.936,4.434c-.031.062-.062.125-.125.125m3.232,6.138a11.168,11.168,0,1,0-7.908-3.271,11.179,11.179,0,0,0,7.908,3.271",
    transform: "translate(-402.878 -198.457)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_925",
    "data-name": "Trazado 925",
    d: "M618.373,247.4l-1.337,3.733h-.942l-1.337-3.733v-.056h.841l.964,2.976h.017l.953-2.976h.841Z",
    transform: "translate(-586.898 -240.92)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_926",
    "data-name": "Trazado 926",
    d: "M643.11,256.734a.616.616,0,0,0,.674.607,2.5,2.5,0,0,0,.858-.167l.173.54a2.6,2.6,0,0,1-1.086.228,1.428,1.428,0,0,1-.039-2.852,1.116,1.116,0,0,1,1.256,1.159,3.4,3.4,0,0,1-.039.484Zm1.142-.468a.436.436,0,0,0,.006-.084.495.495,0,0,0-.563-.546.6.6,0,0,0-.585.63Z",
    transform: "translate(-610.86 -247.644)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_927",
    "data-name": "Trazado 927",
    d: "M668.219,250.4v-1.616c0-.34-.151-.535-.479-.535a.821.821,0,0,0-.579.256V250.4h-.75v-3.9h.752v1.437h.011a1.243,1.243,0,0,1,.8-.306.963.963,0,0,1,1,1.081V250.4Z",
    transform: "translate(-631.759 -240.185)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_928",
    "data-name": "Trazado 928",
    d: "M691.157,247.236h.752v2.685h-.752ZM692.413,246l-.574.763h-.662v-.056l.44-.758h.791Z",
    transform: "translate(-653.252 -239.706)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_929",
    "data-name": "Trazado 929",
    d: "M702.709,255.1a2.541,2.541,0,0,1,.837.162l-.15.574a1.885,1.885,0,0,0-.6-.117.811.811,0,0,0,0,1.616,1.883,1.883,0,0,0,.6-.117l.15.574a2.541,2.541,0,0,1-.837.162,1.426,1.426,0,1,1,0-2.852",
    transform: "translate(-662.046 -247.654)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_930",
    "data-name": "Trazado 930",
    d: "M723.292,255.736v1.616c0,.351.128.535.457.535a.955.955,0,0,0,.568-.228v-1.922h.752v2.685h-.607l-.1-.262h-.011a1.22,1.22,0,0,1-.837.345.943.943,0,0,1-.977-1.075v-1.694Z",
    transform: "translate(-680.507 -248.206)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_931",
    "data-name": "Trazado 931",
    d: "M747.924,246.5v3.3c0,.084.006.1.089.1h.3v.512a2.562,2.562,0,0,1-.446.039c-.512,0-.691-.251-.691-.785V246.5Z",
    transform: "translate(-701.901 -240.185)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_932",
    "data-name": "Trazado 932",
    d: "M759.966,257.954a1.426,1.426,0,1,1,1.421-1.426,1.344,1.344,0,0,1-1.421,1.426m0-.618c.4,0,.651-.267.651-.808s-.256-.808-.651-.808-.646.267-.646.808.262.808.646.808",
    transform: "translate(-711.782 -247.655)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_933",
    "data-name": "Trazado 933",
    d: "M783.414,257.157a1.954,1.954,0,0,0,.864.228c.3,0,.424-.089.424-.262s-.128-.223-.368-.284l-.351-.084a.809.809,0,0,1-.73-.79c0-.529.419-.864,1.116-.864a2.442,2.442,0,0,1,1,.195l-.206.535a2.29,2.29,0,0,0-.774-.162c-.284,0-.407.084-.407.245s.123.212.346.273l.34.084c.429.106.763.329.763.8,0,.558-.446.88-1.131.88a2.3,2.3,0,0,1-1.109-.256Z",
    transform: "translate(-733.185 -247.655)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_934",
    "data-name": "Trazado 934",
    d: "M618.3,289.111a2.6,2.6,0,0,1,1.076.245l-.206.613a1.987,1.987,0,0,0-.869-.195c-.674,0-1.036.529-1.036,1.315s.362,1.315,1.036,1.315a1.987,1.987,0,0,0,.869-.195l.206.613a2.6,2.6,0,0,1-1.076.245,1.983,1.983,0,0,1,0-3.956",
    transform: "translate(-588.37 -277.193)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_935",
    "data-name": "Trazado 935",
    d: "M642.636,300.354a1.426,1.426,0,1,1,1.421-1.426,1.344,1.344,0,0,1-1.421,1.426m0-.618c.4,0,.651-.267.651-.808s-.256-.808-.651-.808-.646.267-.646.808.262.808.646.808",
    transform: "translate(-609.879 -284.481)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_936",
    "data-name": "Trazado 936",
    d: "M667.768,297.582l.093.262h.017a1.262,1.262,0,0,1,.864-.345.886.886,0,0,1,.819.412h.011a1.356,1.356,0,0,1,.981-.412.945.945,0,0,1,.986,1.076v1.694h-.752v-1.616c0-.351-.112-.535-.468-.535a.99.99,0,0,0-.607.256.8.8,0,0,1,.022.2v1.694h-.752v-1.616c0-.34-.117-.535-.473-.535a.962.962,0,0,0-.585.228v1.922h-.752v-2.685Z",
    transform: "translate(-632.42 -284.477)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_937",
    "data-name": "Trazado 937",
    d: "M705.314,299.134a.616.616,0,0,0,.674.607,2.5,2.5,0,0,0,.858-.167l.172.54a2.6,2.6,0,0,1-1.086.228,1.428,1.428,0,0,1-.039-2.852,1.116,1.116,0,0,1,1.256,1.159,3.425,3.425,0,0,1-.039.485Zm1.142-.468a.418.418,0,0,0,.006-.084.5.5,0,0,0-.563-.546.6.6,0,0,0-.585.63Z",
    transform: "translate(-664.885 -284.47)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_938",
    "data-name": "Trazado 938",
    d: "M729.222,297.587l.106.326h.011a.791.791,0,0,1,.68-.407,1.208,1.208,0,0,1,.267.033l-.067.63a1.587,1.587,0,0,0-.267-.022.718.718,0,0,0-.585.262v1.867h-.752V297.59Z",
    transform: "translate(-685.785 -284.483)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_939",
    "data-name": "Trazado 939",
    d: "M744.615,297.5a2.543,2.543,0,0,1,.837.162l-.15.574a1.886,1.886,0,0,0-.6-.117.811.811,0,0,0,0,1.616,1.887,1.887,0,0,0,.6-.117l.15.574a2.544,2.544,0,0,1-.837.162,1.426,1.426,0,0,1,0-2.852",
    transform: "translate(-698.442 -284.48)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_940",
    "data-name": "Trazado 940",
    d: "M764.683,288.3a.413.413,0,1,1-.435.412.406.406,0,0,1,.435-.412M764.3,289.6h.752v2.685H764.3Z",
    transform: "translate(-716.733 -276.493)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_941",
    "data-name": "Trazado 941",
    d: "M776.965,299.686c0,.084.006.1.089.1h.195v.512a1.913,1.913,0,0,1-.39.039.516.516,0,0,1-.535-.318h-.011a1.5,1.5,0,0,1-.864.334.811.811,0,0,1-.908-.847c0-.6.379-.88,1.326-.88h.362V298.5c0-.334-.3-.384-.457-.384a2.307,2.307,0,0,0-.891.195l-.178-.574a2.813,2.813,0,0,1,1.109-.239c.775,0,1.153.4,1.153,1.086Zm-1.019-.574c-.5,0-.685.128-.685.329,0,.223.128.326.357.326a1.18,1.18,0,0,0,.613-.186v-.468Z",
    transform: "translate(-725.672 -284.48)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_942",
    "data-name": "Trazado 942",
    d: "M799.66,288.9v3.3c0,.084.005.1.089.1h.3v.512a2.561,2.561,0,0,1-.446.039c-.512,0-.691-.251-.691-.785V288.9Z",
    transform: "translate(-746.835 -277.01)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_943",
    "data-name": "Trazado 943",
    d: "M811.076,299.134a.616.616,0,0,0,.674.607,2.5,2.5,0,0,0,.858-.167l.172.54a2.6,2.6,0,0,1-1.086.228,1.428,1.428,0,0,1-.039-2.852,1.116,1.116,0,0,1,1.255,1.159,3.38,3.38,0,0,1-.039.485Zm1.143-.468a.427.427,0,0,0,.006-.084.5.5,0,0,0-.563-.546.6.6,0,0,0-.585.63Z",
    transform: "translate(-756.741 -284.47)",
    fill: "#e7e7e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_944",
    "data-name": "Trazado 944",
    d: "M833.286,299.557a1.955,1.955,0,0,0,.864.228c.3,0,.424-.089.424-.262s-.128-.223-.368-.284l-.351-.084a.809.809,0,0,1-.73-.79c0-.529.419-.864,1.116-.864a2.441,2.441,0,0,1,1,.195l-.206.535a2.288,2.288,0,0,0-.774-.161c-.284,0-.407.084-.407.245s.123.212.345.273l.34.084c.429.106.764.329.764.8,0,.558-.446.88-1.131.88a2.3,2.3,0,0,1-1.109-.256Z",
    transform: "translate(-776.5 -284.48)",
    fill: "#e7e7e7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosVw);
export default __webpack_public_path__ + "static/media/logos-vw.c71e5f522f350be5ab341cd8a6299674.svg";
export { ForwardRef as ReactComponent };